<template>
  <!--培训分类-->
  <el-row class="alltext">
     <div v-if="liad_show">
          <load></load>
        </div>
     <div class="firstdiv">
       <el-button type="primary" @click="type_up('add','')">新增分类</el-button>
     </div>
     <div class="content">
      <div class="content_right">
           <span style="font-size: 20px;">培训分类</span>
           <div class="content_right_first">
             <div><el-input v-model="search" placeholder="请输入内容"></el-input></div>
           </div>
           <div>
              <el-table
                  :data="type_list.data"
                  stripe
                  style="width: 100%">
                  <el-table-column
                    prop="num"
                    label="编号"
                    sortable
                   >
                  </el-table-column>
                  <el-table-column
                    prop="a_id"
                    label="录入人"
                   >
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="分类名">
                  </el-table-column>
                  <el-table-column
                    label="操作">
                    <template slot-scope="scope">
                     <i class="el-icon-edit"  style="cursor: pointer;" @click="type_up('edit',scope.row.num)"></i>
                     <i class="el-icon-close" style="cursor: pointer;" @click="type_up('del',scope.row.num)"></i>
                     </template>
                  </el-table-column>
                </el-table>
           </div>
           <div class="block">
             <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
               :current-page="type_list.current_page" :page-sizes="[10, 20, 30, 40]" :page-size="type_list.per_page"
               layout="total, sizes, prev, pager, next, jumper" :total="type_list.total">
             </el-pagination>
           </div>
        </div>
      </div>
     </div>
     <!--新增和编辑弹框-->
     <el-dialog :title="nav_status.title" :visible.sync="nav_status.type_edit_dialog">
        分类名称： <el-input style="width: 70%;" v-model="type_edit.name" placeholder="请输入内容"></el-input>
       <div slot="footer" class="dialog-footer">
           <el-button @click="type_save()">确 定</el-button>
         </div>
     </el-dialog>

  </el-row>
</template>

<script>
  import load from '../../../components/load.vue';
  export default {
    name: 'App',
    data() {
      return {
        liad_show:'',
        nav_status:{
          title:'',
          type_edit_dialog:false
        },
        type_list:{
          current_page: 1, // 当前页码
          total: 0, // 总条数
          per_page: 10,
        },
        type_edit:{},
        search:''
      }
    },
    components: {

    },
    mounted: function() {
      this.get_type()
    },
    methods: {
      get_type(){
        let _this=this
        _this.liad_show=true
        _this.axios.get('/v2/c_train/get_train_type',{params:{'page':_this.type_list.current_page,'limit':_this.type_list.per_page}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.type_list=res.data.data
              _this.type_list.per_page=parseInt(_this.type_list.per_page)
              _this.liad_show=false
            }else{
              _this.$message.error(res.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      handleSizeChange(val) {
        this.type_list.current_page = 1;
        this.type_list.per_page = val
        this.get_type()
      },

      handleCurrentChange(val) {
        let _this=this
        _this.type_list.current_page = val
        _this.get_type()
      },
      //弹框确定按钮时间
      class_Submit(){
       alert(this.class_input);
      },
     //新增编辑分类弹框事件
     type_up(type,num){
       let _this=this
       _this.type_edit.type=type
       if(type=='add'){
         _this.nav_status.title='添加分类'
         _this.nav_status.type_edit_dialog=true
       }else if(type=='edit'){
         _this.get_type_info(num)
       }else{
         _this.$confirm('此操作将永久删除该分类, 是否继续?', '提示', {
           confirmButtonText: '确定',
           cancelButtonText: '取消',
           type: 'warning'
         }).then(() => {
           _this.type_edit.num=num
           _this.type_save()
         }).catch(() => {

         });

       }
     },

     type_save(){
       let _this=this
       _this.nav_status.title='编辑分类'
       _this.axios.post('/v2/c_train/train_type_up',{data:_this.type_edit}).then(function(res) {
         if(res.status=='200'){
           if(res.data.code=='1'){
             _this.$message.success(res.data.msg)
             _this.get_type()
             _this.nav_status.type_edit_dialog=false
           }else{
             _this.$message.error(res.data.msg)
           }
         }else{
           _this.$message.error('服务器内部错误')
         }
       }).catch(function(error) {
         _this.$message.error('服务器内部错误')
       });
     },

     get_type_info(num){
       let _this=this
       _this.axios.get('/v2/c_train/get_train_type_info',{params:{'num':num}}).then(function(res) {
         if(res.status=='200'){
           if(res.data.code=='1'){
             _this.type_edit=res.data.data
             _this.type_edit.type='edit'
             _this.nav_status.type_edit_dialog=true
           }else{
             _this.$message.error(res.data.msg)
           }
         }else{
           _this.$message.error('服务器内部错误')
         }
       }).catch(function(error) {
         _this.$message.error('服务器内部错误')
       });
     },

    }
  }
</script>

<style scoped>
  .block {
    text-align: center;
    margin-top: 20px;
  }
  .alltext{
  margin: 20px;
  background-color: white;
   height: calc(100vh - 40px);
  width: 95%;
  border:1px solid 	#9D9D9D;
}
.firstdiv{
  margin-top: 10px;

  width: 95%;
  height: 70px;
  display: flex;
  align-items: center;
  padding-left: 20px;
}
.content{
  width: 96%;
  margin-top: 10px;
}
.content_right_first{
    margin: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .content_right{

    padding: 20px;
  }
  .fenye{
    text-align: center;
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/view/company/train/TClass.vue